import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import topTitle from '@/components/title';
import pictureItem from './picture.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    topTitle,
    pictureItem
  },
  props: {
    infoList: {
      type: Array,
      default() {
        return [];
      }
    },
    editableAreaInfo: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      infoList2: [],
      previewVisible: false,
      previewImage: ''
    };
  },
  mounted() {
    if (this.editableAreaInfo.length != 0) {
      let name = '';
      this.editableAreaInfo.map(item => {
        if (item.operation != 'addEditDel' && item.controlType == 'table') {
          name = item.operation;
        }
      });
      if (name) {
        this.dataFun(name);
        return false;
      }
      this.infoList2 = recursionCopy(this.infoList);
    } else {
      let name = '';
      let arr = recursionCopy(this.infoList);
      arr.map((item, index) => {
        item.sharedData.map((item2, index2) => {
          if (item.method == 'COUNTERSIGN') {
            item2.editableArea.map((item3, index3) => {
              if (item3.controlType == 'table' && item3.operation == 'lossDetermination' || item3.controlType == 'table' && item3.operation == 'nuclearDamage') {
                name = item3.operation;
              }
            });
          } else {
            if (item2.operation == 'lossDetermination' || item2.operation == 'nuclearDamage') {
              name = item2.operation;
            }
          }
        });
      });
      console.log(name);
      if (name) {
        this.dataFun(name);
        return false;
      }
      this.infoList2 = recursionCopy(this.infoList);
    }
    console.log(this.infoList2, 'iii');

    //   let name = '';
    //   this.infoList.map(item => {
    //     item.sharedData.map(item2 => {

    //       if (item.method != 'ORSIGN') {
    //         item2.editableArea.map(item3 => {
    //           console.log(item3);
    //           if (name == item3.controlTitle && item3.controlTitle) {

    //           }
    //         })

    //       }
    //     });

    //   });
  },
  methods: {
    photoFun(url) {
      console.log(url);
    },
    dataFun(name) {
      let arr = recursionCopy(this.infoList);
      const name2 = name == 'nuclearDamage' ? 'lossDetermination' : 'addEditDel';
      for (let i = 0; i < arr.length; i++) {
        console.log(arr[i]);
        for (let j = 0; j < arr[i].sharedData.length; j++) {
          if (arr[i].method != 'COUNTERSIGN') {
            if (arr[i].sharedData[j].operation == name2) {
              arr[i].sharedData.splice(j, 1);
              j = j - 1;
            }
          } else {
            for (let a = 0; a < arr[a].sharedData[j].editableArea.length; a++) {
              if (arr[a].sharedData[j].editableArea[a].operation == name2) {
                arr[a].sharedData[j].editableArea.splice(a, 1);
                a = a - 1;
              }
            }
          }
        }
      }
      this.infoList2 = arr;
    }
  }
};